module.exports = __webpack_public_path__ + "static/Kollektif-4d49be6e42d18464b230d87d1fab175a.ttf";